import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch actions for a specific community group
 */
export const GET_COMMUNITY_GROUP_ACTIONS = gql`
  query GetCommunityGroupActions($communityGroupId: ID!) {
    communityGroup(id: $communityGroupId) {
      id
      actions {
        name
        type
        description
        deliveryType
        labels {
          labelId
          severity
        }
        policies
        operatorName
        deliverySettings {
          url
          postPayload
        }
      }
    }
  }
`;
